export default __webpack_public_path__ + "static/media/corporate-icon.23e0a7b4.svg";